import React, { useMemo } from 'react';
import { Card, Avatar, Typography, Tag, Button, Space, Tooltip, Flex } from 'antd';
import { EditOutlined, ReloadOutlined, UserOutlined, MailOutlined, CheckCircleFilled } from '@ant-design/icons';
import { useLanguage } from 'src/providers/LanguageProvider';
import { useSelector } from 'react-redux';

const ProfilePageHeader = () => {
  const { t } = useLanguage();
  const account = useSelector((e: any) => e.auth.account);

  const profileImageUrl = useMemo(
    () => (account?.Id ? `/api/v1/profile/upload/${account.Id}` : undefined),
    [account]
  );

  const fullName = useMemo(
    () => (account ? `${account?.FirstName || ''} ${account?.LastName || ''}`.trim() : ''),
    [account]
  );

  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 16,
        background:
          'linear-gradient(135deg, rgba(59,130,246,0.12) 0%, rgba(99,102,241,0.12) 50%, rgba(236,72,153,0.12) 100%)',
      }}
      bodyStyle={{ padding: 16 }}
    >
      <Flex align="center" justify="space-between" wrap="wrap" gap={16}>
        <Flex align="center" gap={16}>
          <Avatar
            size={72}
            src={profileImageUrl}
            icon={<UserOutlined />}
            aria-label={t('ARIA_PROFILE_AVATAR')}
          />
          <div>
            <Flex align="center" gap={8} wrap="wrap">
              <Typography.Title level={4} style={{ margin: 0 }}>
                {fullName || t('USER')}
              </Typography.Title>

              {account?.IsConfirm ? (
                <Tag color="blue" icon={<CheckCircleFilled />}>
                  {t('PROFILE_CONFIRMED')}
                </Tag>
              ) : (
                <Tag>{t('PROFILE_UNVERIFIED')}</Tag>
              )}

              <Tag color={account?.IsActive ? 'green' : 'red'}>
                {account?.IsActive ? t('STATUS_ACTIVE') : t('STATUS_PASSIVE')}
              </Tag>
            </Flex>

            {account?.Email && (
              <Typography.Text type="secondary">
                <MailOutlined /> {account.Email}
              </Typography.Text>
            )}
          </div>
        </Flex>

        <Space wrap>
          <Tooltip title={t('PROFILE_EDIT')}>
            <Button
              icon={<EditOutlined />}
              onClick={() =>
                document.getElementById('profile-form')?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              {t('PROFILE_EDIT')}
            </Button>
          </Tooltip>

          <Tooltip title={t('REFRESH')}>
            <Button
              icon={<ReloadOutlined />}
              onClick={async () => {
                /* refresh action burada olacak */
              }}
            />
          </Tooltip>
        </Space>
      </Flex>
    </Card>
  );
};

export default ProfilePageHeader;
